module.exports = __webpack_public_path__ + "static/media/BA.5fab9cd1.jpg";